import CustomField from '../CustomField';
import moment from 'moment';

const UNSUPPORTED_FIELD_TYPES = ['EquationField'];

function getExampleContent(fieldType) {
  const exampleContent = {
    DateField: moment()
      .add(6, 'months')
      .strftime(window.currentUser?.dateFormat),
    EquationField: '=9+3',
    ScorecardField: '20',
    SelectConstant: 'Predefined choice list',
    SelectEditable: 'Predefined choice list',
    TextField: 'Example text',
  };

  return exampleContent[fieldType];
}

export default class PlainTextCustomField extends CustomField {
  exampleContents() {
    const exampleContent = getExampleContent(this.customFieldDefinition.type);

    return {
      text: exampleContent,
    };
  }

  contentsForRecord(record) {
    if (UNSUPPORTED_FIELD_TYPES.includes(this.type)) {
      return {};
    }

    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.value) {
      return {
        text: customFieldValue.value,
      };
    }

    return {};
  }
}
